var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"block-title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.alphabet)?_c(_vm.alphabetComponent,{tag:"component",attrs:{"color":_vm.colorScheme.second}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2063160c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/recommend/lp/partials/LpTitle.vue
// module id = null
// module chunks = 